import React, { createRef } from 'react';
import { IonLoading, IonSelect, IonSelectOption, IonModal, IonTextarea, IonAlert, IonItemSliding, IonItemOptions, IonItemOption, IonToggle, IonListHeader, IonButton, IonChip, IonCard, IonCardHeader, IonCardTitle, IonCardContent, IonActionSheet, IonInput, IonButtons, IonBackButton, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle, IonAvatar } from '@ionic/react';
import '../styles/Studyset.scss';
import '../styles/DropboxAuthModal.scss';
import '../styles/Settings.scss';
import Storage from '../Storage';
import SQLStorage from '../SQLStorage';
import Utilities from '../Utilities';
import TagEditorModal from './TagEditorModal';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { checkmarkCircle, headset, star, pricetag, close, volumeHigh, trash, more, add, albums, wallet, bulb, gitMerge, school, chevronForward, checkmarkDoneCircle, informationCircleSharp, alertCircleSharp } from 'ionicons/icons'
import store from '../state/store';
import Server from '../Server';
import { updatedSetsSet } from '../state/actions/UpdatedSets';
import ContactUs from './ContactUs';
import LanguagePickerModal from './LanguagePicker';
import Avatar from "boring-avatars";
import TeamSvg from '../images/team.svg';

import { Device } from '@capacitor/device';
import { Share } from '@capacitor/share';
import { Clipboard } from '@capacitor/clipboard';
import { LocalNotifications } from '@capacitor/local-notifications';
import { Filesystem, Directory, Encoding } from '@capacitor/filesystem';

const DEFAULT_SPACED_REPETITION = [
    { hours: 24 }, // 1 day -> 1st day
    { hours: 48 }, // 2 days -> 3rd day
    { hours: 96, learnt: true }, // 4 days -> 7th day
    { hours: 192 }, // 8 days -> 15th day
    { hours: 384, mastered: true } // 16 days -> 31st day
]

class Settings extends React.Component {

    constructor(props) {
        super(props);
        this.pageRef = createRef();
        this.state = {
            dropboxToggled: null,
            tags: [],
            currentlyEditedTag: null,
            toBeDeletedTagId: null,
            deleteTagConfirmationAlert: false,
            settings: {},
            dropboxStartSyncDisabled: false,
            dropboxStatus: "",
            deviceInfo: {},
            copyToClipboardText: window.ln.copyToClipboard,
            spacedRepetitionCycles: DEFAULT_SPACED_REPETITION,
            spacedRepetitionEdited: null,
            infoAdminCount: 0,
            infoAdminCount2: 0,
            languagePickerModal: null,
            contactUsSheet: null,
            accountAction: false,
            fullscreenLoading: null
        }
    }

    async saveSettings() {
        await Storage.setO("settings", this.state.settings);
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.open !== this.props.open && nextProps.open) {
            this.ionViewWillEnter();
        }
    }

    async ionViewWillEnter() {

        Utilities.trackEvent("Settings", "Settings Page View");

        let settings = await Storage.getO("settings");
        let tags = await SQLStorage.getTags();
        let deviceInfo = await Device.getInfo();
        let sqlSettings = await SQLStorage.getSettingsObj();

        if (!settings) {
            setTimeout(function() {
                this.ionViewWillEnter();
            }.bind(this), 100)
        }

        this.setState({ 
            goalNumber: sqlSettings.goalNumber ? parseInt(sqlSettings.goalNumber) : 0,
            dailyCatchUpTime: sqlSettings.dailyCatchUpTime ? sqlSettings.dailyCatchUpTime : "Off",
            spacedRepetitionCycles: sqlSettings.spacedRepetitionCycles ? JSON.parse(sqlSettings.spacedRepetitionCycles) : DEFAULT_SPACED_REPETITION
        });

        if (sqlSettings.lang) {
            settings.lang = sqlSettings.lang
        }

        if (settings) {
            if (sqlSettings.account) {
                settings.account = JSON.parse(sqlSettings.account)
            } else {
                settings.account = null
            }
        }

        if (settings.dropbox) {
            this.setState({ dropboxToggled: true })
        } else {
            this.setState({ dropboxToggled: false })
        }

        this.setState({
            settings: settings,
            tags: tags,
            deviceInfo: deviceInfo
        })

        store.subscribe(() => {
            const stateCal = store.getState().calendar;
            if (stateCal && stateCal.syncStatus) {
                this.setState({ dropboxStatus: stateCal.syncStatus })
            }
        });

        if (localStorage.getItem("auto-signup-tap")) {
            localStorage.removeItem("auto-signup-tap");
            this.setState({
                accountAction: "signup"
            })
        }

        if (localStorage.getItem("autoBackupImportPrompt")) {
            localStorage.removeItem("autoBackupImportPrompt");
            const element = document.getElementById("backup-upload-input");
            if (element) {
                element.click();
            }
        }

    }

    dropboxSyncToggle(onlyOn) {

        if (this.state.dropboxToggled) {
            if (onlyOn) {
                window.toast(window.ln.dropboxAlreadyLinked, "info")
                return;
            }
            Utilities.trackEvent("Dropbox", "Dropbox Toggle", "Off")
            let settings = this.state.settings;
            settings.dropbox = null;
            this.setState({
                settings: settings,
                dropboxToggled: false,
            }, async function() {
                await this.saveSettings();
                localStorage.setItem("preventAppOpenTrack", "true")
                window.location.reload();
            })
        } else {
            window.startDropboxAuth();
            Utilities.trackEvent("Dropbox", "Dropbox Toggle", "On")
        }

    }

    editTag = (id) => {

        this.setState({
            currentlyEditedTag: (id === "new") ? {
                id: "" + Utilities.getId(),
                color: "1",
                name: "",
                createdAt: Utilities.timestamp(),
                updatedAt: Utilities.timestamp(),
            } : this.state.tags.filter(item => { return (item.id === id) })[0]
        })

    }

    async deleteTag(id) {

        let tags = this.state.tags;

        for (let i = 0; i < tags.length; i++) {
            if (tags[i].id === id) {
                tags.splice(i, 1);
                break;
            }
        }

        this.setState({
            tags: tags,
        })

        Utilities.trackEvent("Tag", "Tag Delete", id);

        await SQLStorage.deleteTag(id);
        await window.dropbox.queueForUpload("tag", id)
        window.dropbox.debounce(true);

    }

    async export() {

        Utilities.trackEvent("Export", "Full Export")
            
        this.setState({ fullscreenLoading: window.ln.preparingFile })

        let data = await SQLStorage.fullExport();

        const fileName = "fms_backup-" + Utilities.formatDate(new Date(), "YYYY-MM-DD") + '.json'

        let dataToWrite = JSON.stringify(data);

        if (this.state.deviceInfo.platform === "ios" || this.state.deviceInfo.platform === "android" ) {

            let res = await Filesystem.writeFile({ path: fileName, directory: Directory.Data, data: dataToWrite, encoding: Encoding.UTF8 }).catch(e => {
                console.error("Failed to write file", e)
                window.toast(window.ln.smFileError, "error");
                this.setState({ loading: false, printing: false });
            })

            let uri = await Filesystem.getUri({ directory: Directory.Data, path: fileName });

            Share.share({
                files: [uri.uri],
                title: fileName,
            })
        } else {

            var dataStr = "data:application/json;charset=utf-8," + encodeURIComponent(dataToWrite);
            var downloadAnchorNode = window.document.createElement('a');
            downloadAnchorNode.setAttribute("href", dataStr);
            downloadAnchorNode.setAttribute("download", fileName);
            window.document.body.appendChild(downloadAnchorNode);
            downloadAnchorNode.click();
            downloadAnchorNode.remove();

        }

        this.setState({ fullscreenLoading: null })
    
    }

    async import(e) {
        Utilities.trackEvent("Export", "Full Import")

        this.setState({ fullscreenLoading: window.ln.importing })

        const file = e.target.files[0];

        const reader = new FileReader();

        reader.addEventListener("load", async function () {
            try {
                await SQLStorage.fullImport(JSON.parse(reader.result))
                localStorage.setItem("preventAppOpenTrack", "true")
                window.location.href = "/"
            } catch (e) {
                this.setState({ fullscreenLoading: null })
                window.toast(window.ln.importErr + " " + e, "error");
            }
        }.bind(this), false);

        reader.readAsText(file);
    }

    async saveTag(tag) {

        let tags = this.state.tags;
        let tagI;

        for (let i = 0; i < tags.length; i++) {
            if (tags[i].id === tag.id) {
                tagI = i;
                break;
            }
        }

        if (tagI) {
            tag.updatedAt = new Date();
            tags[tagI] = tag;
        } else {
            tags.push(tag);
        }

        this.setState({
            tags: tags,
            currentlyEditedTag: null
        })

        await SQLStorage.saveTag(tag);
        await window.dropbox.queueForUpload("tag", tag.id);
        window.dropbox.debounce(true);

    }

    copyToClipboard() {
        Clipboard.write({ string: this.state.raw });
        this.setState({ copyToClipboardText: window.ln.copied })
        setTimeout(function() { this.setState({ copyToClipboardText: window.ln.copyToClipboard }) }.bind(this), 3000)
    }

    render() {

        return (
        <IonPage data-page="settings" ref={this.pageRef}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle onClick={() => {
                        // if (this.state.infoAdminCount > 2) {
                        //     this.promoCode()
                        // }
                        this.setState({ infoAdminCount: this.state.infoAdminCount+1 });
                    }}>{window.ln.settings}</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <div>
                <IonList>
                    { (!window.activated) &&
                        <div className="premium top-info" onClick={() => {
                            localStorage.setItem("preventAppOpenTrack", "true")
                            window.location.href = "/subscription"
                        }}>
                            <div className="side">
                                {/* <h2>{window.ln.promoH2}</h2> */}
                                <p>{window.ln.promoP}</p>
                                <img src={TeamSvg} />
                                {/* <button>{window.ln.promoBtn}</button> */}
                            </div>
                        </div>
                    }

                    <ContactUs />

                    <IonListHeader>
                        <IonLabel>{window.ln.setDropboxH2}</IonLabel>
                    </IonListHeader>

                    { (!this.state.settings.dropbox) ?
                        <p>{window.ln.setDropboxPOff}</p>
                        :
                        <p>{window.ln.setDropboxPOn}</p>
                    }
                    { (this.state.dropboxToggled !== null) &&
                        <IonItem className="long">
                            <IonLabel>{window.ln.setDropboxBtn}</IonLabel>
                            <IonToggle
                                checked={this.state.dropboxToggled}
                                onIonChange={(e) => { this.dropboxSyncToggle(); }}
                            />
                        </IonItem>
                    }
                    { (this.state.settings.dropbox && this.state.dropboxStatus) &&
                        <IonItem className="long">
                            <IonLabel>{window.ln.status}</IonLabel>
                            <IonLabel className="ion-text-wrap">{this.state.dropboxStatus.startsWith("Updated at") ? "Updated " + Utilities.timeSince(new Date(parseInt(this.state.dropboxStatus.replace("Updated at ", ""))*1000)) : this.state.dropboxStatus}</IonLabel>
                        </IonItem>
                    }
                    { (this.state.settings.dropbox) &&
                        <IonItem className="long sync-now" onClick={() => {
                            window.dropbox.startSync();
                            this.setState({ dropboxStatus: "Checking for updates" })
                        }}>
                            <IonLabel>{window.ln.syncNow}</IonLabel>
                        </IonItem>
                    }
                    { (this.state.settings.dropbox) &&
                        <IonItem style={{ '--border-color': 'transparent' }} className="long sync-now" onClick={() => {
                            window.preventFocusBlurTrack = true;
                            if (window.confirm(window.ln.consolidateStorageDescription || "")) {
                                window.preventFocusBlurTrack = true;
                                if (window.confirm(window.ln.consolidatingStorageConfirm)) {
                                    localStorage.setItem("preventAppOpenTrack", "true");
                                    localStorage.setItem("consolidateStorage", "true");
                                    localStorage.setItem("consolidateStorageTimestamp", Utilities.timestamp());
                                    window.location.href = "/";
                                }
                                setTimeout(() => {
                                    window.preventFocusBlurTrack = false;
                                }, 300);
                            }
                            setTimeout(() => {
                                window.preventFocusBlurTrack = false;
                            }, 300);
                        }}>
                            <IonLabel>{window.ln.consolidateStorage}</IonLabel>
                        </IonItem>
                    }

                    <IonListHeader>
                        <IonLabel>{window.ln.manualBackups}</IonLabel>
                    </IonListHeader>

                    <IonItem style={{ '--border-color': 'transparent' }} onClick={() => {
                        this.export();
                    }}>
                        <IonLabel>{window.ln.manualBackupCreate}</IonLabel>
                    </IonItem>

                    <IonItem 
                        id="trigger-import-btn"
                        onClick={() => {
                            window.preventFocusBlurTrack = true;
                            if (window.confirm(window.ln.confirmManualImport)) {
                                const element = document.getElementById("backup-upload-input");
                                if (element) {
                                    element.click();
                                }
                            }
                            setTimeout(() => {
                                window.preventFocusBlurTrack = false;
                            }, 300);
                        }}
                    >
                        <IonLabel>{window.ln.importFromManualBackup}</IonLabel>
                    </IonItem>

                    <input id="backup-upload-input" multiple={false} style={{ display: "none" }} type='file' onChange={ async (e) => {
                        this.import(e);
                    }} />

                    <IonListHeader onClick={() => {
                        if (this.state.infoAdminCount2 > 5) {
                            // let code = localStorage.getItem("adminpass") || window.prompt("CCOOOOODE: ")
                            // if (code && !localStorage.getItem("adminpass")) {
                            //     localStorage.setItem("adminpass", code);
                            // }
                            // if (code)
                            //     this.props.history.push("/allsets")

                            this.setState({ adminOpts: true });
                        }
                        this.setState({ infoAdminCount2: this.state.infoAdminCount2+1 });
                    }}>
                        <IonLabel>{window.ln.siteLoginH2}</IonLabel>
                    </IonListHeader>

                    <p>{window.ln.siteLoginP}</p>

                    { (this.state.settings.account && this.state.settings.account.username) ?
                        <React.Fragment>
                            <IonItem 
                                className="long"
                                onClick={ async () => {
                                    window.preventFocusBlurTrack = true;
                                    if (window.confirm(window.ln.logOut + "?")) {
                                        Utilities.trackEvent("Account", "Account Logout");
                                        await SQLStorage.saveSetting("account", "");
                                        await window.dropbox.queueForUpload("setting", "account");
                                        store.dispatch(updatedSetsSet(['null']))
                                        window.dropbox.debounce(true);
                                        localStorage.setItem("preventAppOpenTrack", "true")
                                        window.location.reload();
                                    }
                                    setTimeout(() => {
                                        window.preventFocusBlurTrack = false;
                                    }, 300);
                                }}
                            >
                                <IonAvatar slot="start">
                                    { (this.state.settings.account.image) ?
                                        <img width="40" height="40" src={this.state.settings.account.image} />
                                        :
                                        <Avatar
                                            size={40}
                                            name={this.state.settings.account.username}
                                            variant="beam"
                                            colors={["#92A1C6", "#146A7C", "#F0AB3D", "#C271B4", "#C20D90"]}
                                        />
                                    }
                                </IonAvatar>
                                <IonLabel>{this.state.settings.account.username}</IonLabel>
                                <IonLabel className="ion-text-wrap">{window.ln.logOut}</IonLabel>
                            </IonItem>
                            <IonItem 
                                onClick={ async () => {
                                    window.preventFocusBlurTrack = true;
                                    if (window.confirm((window.ln.deleteAccountConfirm || "Are you sure you want to delete your account? This action cannot be undone."))) {
                                        Utilities.trackEvent("Account", "Account Deletion");
                                        const res = await Server.deleteAccount(this.state.settings.account.email, this.state.settings.account.password);
                                        window.toast(window.ln.accountDeleted || "Account Deleted", "success");
                                        setTimeout(async () => {
                                            await SQLStorage.saveSetting("account", "");
                                            await window.dropbox.queueForUpload("setting", "account");
                                            store.dispatch(updatedSetsSet(['null']))
                                            window.dropbox.debounce(true);
                                            localStorage.setItem("preventAppOpenTrack", "true")
                                            window.location.reload();
                                        }, 1000)
                                    }
                                    setTimeout(() => {
                                        window.preventFocusBlurTrack = false;
                                    }, 300);
                                }}
                            >
                                <IonLabel slot='start'>{window.ln.deleteAccount}</IonLabel>
                            </IonItem>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            <IonItem onClick={() => {
                                this.setState({ accountAction: "login" })
                            }}>
                                <IonLabel>{window.ln.logIn}</IonLabel>
                            </IonItem>
                            <IonItem onClick={() => {
                                this.setState({ 
                                    accountAction: "signup",
                                    password: "" // bip39.generateMnemonic().split(" ").slice(0, 4).join("-")
                                })
                            }}>
                                <IonLabel>{window.ln.createAccount}</IonLabel>
                            </IonItem>
                        </React.Fragment>
                    }

                    <IonListHeader>
                        <IonLabel>{window.ln.language}</IonLabel>
                    </IonListHeader> 

                    <IonItem position="stacked" onClick={() => { this.setState({ languagePickerModal: true }) }}>
                        <IonLabel>{ (this.state.settings && this.state.settings.lang) ? window.LANGUAGES[this.state.settings.lang] : "English" }</IonLabel>
                    </IonItem>

                    <IonListHeader>
                        <IonLabel>{window.ln.notifications}</IonLabel>
                    </IonListHeader>

                    <IonItem style={{ '--border-color': 'transparent' }}>
                        <IonLabel>{window.ln.notificationDailyCatchUpTitle}</IonLabel>
                        <IonSelect
                            onIonChange={ async (i) => { 
                                Utilities.trackEvent("Catchup Notification", "Catchup Notification Update", i.detail.value);
                                this.setState({ dailyCatchUpTime: i.detail.value }); 
                                await SQLStorage.saveSetting("dailyCatchUpTime", i.detail.value);
                                await window.dropbox.queueForUpload("setting", "dailyCatchUpTime");
                                store.dispatch(updatedSetsSet(['null']))
                                window.dropbox.debounce(true);
                                if (i.detail.value !== "Off") {
                                    let permissionState = await LocalNotifications.checkPermissions();

                                    if (permissionState.display === "denied") {
                                        window.toast("Notifications were disabled, enable in settings", "error");
                                        return
                                    } else if (permissionState.display === "granted") {
                                    } else {
                                        permissionState = await LocalNotifications.requestPermissions();
                                        return;
                                    }
                                }
                            }}
                            value={this.state.dailyCatchUpTime || window.ln.off}
                        >
                            {/* <IonSelectOption value={0}>{window.ln.off}</IonSelectOption> */}
                            { ['Off', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'].map((item, i) => {
                                return (<IonSelectOption key={item} value={item}>{item}</IonSelectOption>)
                            }) }
                        </IonSelect>
                    </IonItem>

                    <IonListHeader>
                        <IonLabel>{window.ln.archivedCards}</IonLabel>
                    </IonListHeader> 

                    <IonItem position="stacked" onClick={() => { this.props.history.push("/studyset/archived"); }}>
                        <IonLabel>{window.ln.archivedCards}</IonLabel>
                    </IonItem>

                    <IonListHeader>
                        <IonLabel>{window.ln.contact}</IonLabel>
                    </IonListHeader>

                    <IonItem position="stacked" onClick={() => { this.setState({ contactUsSheet: true }) }}>
                        <IonLabel>{window.ln.contactUs}</IonLabel>
                    </IonItem>
                    { (this.state.deviceInfo.platform === "ios" || this.state.deviceInfo.platform === "android" ) &&
                        <IonItem onClick={() => {
                            Utilities.trackEvent("Use from Browser", "Use from Browser Show");
                            window.preventFocusBlurTrack = true;
                            window.alert(window.ln.useFromBrowserMsg)
                            setTimeout(() => {
                                window.preventFocusBlurTrack = false;
                            }, 300);
                        }}>
                            <IonLabel>{window.ln.useFromBrowser}</IonLabel>
                        </IonItem>
                    }
                    <IonItem onClick={() => {
                        Utilities.trackEvent("Chill'n'Study", "Chill'n'Study Open");
                        window.open("https://chillnstudy.com");
                    }}>
                        <IonLabel>In Partnership with Chill'n'Study</IonLabel>
                    </IonItem>
                    { (this.state.deviceInfo.platform === "ios") &&
                        <IonItem onClick={() => {
                            Utilities.trackEvent("Rate", "Open AppStore", "Settings")
                            window.open("https://itunes.apple.com/gb/app/id1496147001")
                        }}>
                            <IonLabel>{window.ln.rateAppStore}</IonLabel>
                        </IonItem>
                    }
                    { (this.state.deviceInfo.platform === "android") &&
                        <IonItem onClick={() => {
                            Utilities.trackEvent("Rate", "Open GooglePlay", "Settings")
                            window.open("https://play.google.com/store/apps/details?id=com.dominikgyecsek.simplecards")
                        }}>
                            <IonLabel>{window.ln.rateGoogle}</IonLabel>
                        </IonItem>
                    }
                    <IonItem style={{ '--border-color': 'transparent' }} onClick={() => { 
                        window.open("https://flashcardsmadesimple.com/terms")
                    }}>
                        <IonLabel>{window.ln.termsPrivacy}</IonLabel>
                    </IonItem>

                    <IonListHeader>
                        <IonLabel>{window.ln.dailyReviewGoal}</IonLabel>
                    </IonListHeader>

                    { (this.state.goalNumber !== undefined && this.state.goalNumber !== null) &&
                        <IonItem style={{ '--border-color': 'transparent' }}>
                            <IonLabel>{window.ln.numberTerms}</IonLabel>
                            <IonSelect
                                onIonChange={ async (i) => { 
                                    Utilities.trackEvent("Daily Goal", "Daily Goal Update", i.detail.value);
                                    this.setState({ goalNumber: i.detail.value }); 
                                    await SQLStorage.saveSetting("goalNumber", i.detail.value);
                                    await window.dropbox.queueForUpload("setting", "goalNumber");
                                    store.dispatch(updatedSetsSet(['null']))
                                    window.dropbox.debounce(true);
                                }}
                                value={this.state.goalNumber || 0}
                            >
                                <IonSelectOption value={0}>{window.ln.off}</IonSelectOption>
                                { [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 60, 70, 80, 90, 100].map((item, i) => {
                                    return (<IonSelectOption key={item.hours} value={item}>{item} {window.ln.terms}</IonSelectOption>)
                                }) }
                            </IonSelect>
                        </IonItem>
                    }

                    <IonListHeader>
                        <IonLabel>{window.ln.spacedRepetition}</IonLabel>
                    </IonListHeader>

                    <p>{window.ln.spacedRepetitionP}</p>
                    
                    { (this.state.spacedRepetitionCycles.map((item, i) => {
                        let hoursSoFar = 0;
                        for (let j = 0; j <= i; j++) {
                            hoursSoFar += this.state.spacedRepetitionCycles[j].hours
                        }
                        return (
                            <IonItemSliding key={i}>
                                <IonItem>
                                    <IonLabel>{window.ln.spacedRepetionScheduleItem.replace("__", item.hours/24).replace("___", Utilities.getGetOrdinal(i+1)).replace("____", hoursSoFar/24)}</IonLabel>
                                    { item.learnt && <IonIcon style={{ color: '#06D6A0' }} slot="end" icon={checkmarkCircle} /> }
                                    { item.mastered && <IonIcon style={{ color: '#118AB2' }} slot="end" icon={checkmarkDoneCircle} /> }
                                </IonItem>
                                <IonItemOptions side="end">
                                    <IonItemOption onClick={() => {
                                        if (!window.activated) {
                                            window.showSubscriptionModal("reviewschedule");
                                        } else {
                                            this.setState({ spacedRepetitionEdited: { i: i, value: item.hours / 24 } })
                                            Utilities.trackEvent("Spaced Repetition", "Spaced Repetition Update");
                                        }
                                    }} >Edit</IonItemOption>
                                    <IonItemOption color="danger" onClick={async () => {
                                        if (!window.activated) {
                                            window.showSubscriptionModal("reviewschedule");
                                        } else {
                                            Utilities.trackEvent("Spaced Repetition", "Spaced Repetition Delete");
                                            let spacedRepetitionCycles = this.state.spacedRepetitionCycles;
                                            if (spacedRepetitionCycles.length < 2) {
                                                window.toast(window.ln.atLeastOneSchedule, "error");
                                            } else {
                                                spacedRepetitionCycles.splice(i, 1)
                                                this.setState({ spacedRepetitionCycles: spacedRepetitionCycles });
                                                await SQLStorage.saveSetting("spacedRepetitionCycles", JSON.stringify(spacedRepetitionCycles))
                                                await window.dropbox.queueForUpload("setting", "spacedRepetitionCycles");
                                                store.dispatch(updatedSetsSet(['null']))
                                                window.dropbox.debounce(true);
                                            }
                                        }    
                                    }} >Delete</IonItemOption>
                                </IonItemOptions>
                            </IonItemSliding>
                        )
                    })) }
                    <IonItem onClick={() => {
                        if (!window.activated) {
                            window.showSubscriptionModal("reviewschedule");
                        } else {
                            Utilities.trackEvent("Spaced Repetition", "Spaced Repetition Create");
                            if (this.state.spacedRepetitionCycles > 19) {
                                window.toast(window.ln.revisionLimitReached, "error");
                            } else {
                                this.setState({ spacedRepetitionEdited: { i: "new", value: null } })
                            }
                        }
                    }}>
                        <IonIcon icon={add} slot="end" lines="none" />
                        <IonLabel>{window.ln.addReviewSchedule}</IonLabel>
                    </IonItem>

                    <IonItem style={{ marginTop: 20 }}>
                        <IonLabel>{window.ln.autoMarkLearnt}</IonLabel>
                        <IonSelect
                            onIonChange={ async (i) => { 
                                let spacedRepetitionCycles = this.state.spacedRepetitionCycles;
                                for (let j = 0; j < spacedRepetitionCycles.length; j++) {
                                    if (i.detail.value === 21) {
                                        spacedRepetitionCycles[j].learnt = false;
                                    } else {
                                        spacedRepetitionCycles[j].learnt = (i.detail.value === j)
                                    }
                                }
                                Utilities.trackEvent("Spaced Repetition", "Spaced Repetition Update Learnt", null, i.detail.value);
                                this.setState({ spacedRepetitionCycles: spacedRepetitionCycles });
                                await SQLStorage.saveSetting("spacedRepetitionCycles", JSON.stringify(spacedRepetitionCycles))
                                await window.dropbox.queueForUpload("setting", "spacedRepetitionCycles");
                                store.dispatch(updatedSetsSet(['null']))
                                window.dropbox.debounce(true);
                            }} 
                            value={
                                (this.state.spacedRepetitionCycles[0] && this.state.spacedRepetitionCycles[0].learnt) ? 0 :
                                (this.state.spacedRepetitionCycles[1] && this.state.spacedRepetitionCycles[1].learnt) ? 1 :
                                (this.state.spacedRepetitionCycles[2] && this.state.spacedRepetitionCycles[2].learnt) ? 2 :
                                (this.state.spacedRepetitionCycles[3] && this.state.spacedRepetitionCycles[3].learnt) ? 3 :
                                (this.state.spacedRepetitionCycles[4] && this.state.spacedRepetitionCycles[4].learnt) ? 4 :
                                (this.state.spacedRepetitionCycles[5] && this.state.spacedRepetitionCycles[5].learnt) ? 5 :
                                (this.state.spacedRepetitionCycles[6] && this.state.spacedRepetitionCycles[6].learnt) ? 6 :
                                (this.state.spacedRepetitionCycles[7] && this.state.spacedRepetitionCycles[7].learnt) ? 7 :
                                (this.state.spacedRepetitionCycles[8] && this.state.spacedRepetitionCycles[8].learnt) ? 8 :
                                (this.state.spacedRepetitionCycles[9] && this.state.spacedRepetitionCycles[9].learnt) ? 9 :
                                (this.state.spacedRepetitionCycles[10] && this.state.spacedRepetitionCycles[10].learnt) ? 10 :
                                (this.state.spacedRepetitionCycles[11] && this.state.spacedRepetitionCycles[11].learnt) ? 11 :
                                (this.state.spacedRepetitionCycles[12] && this.state.spacedRepetitionCycles[12].learnt) ? 12 :
                                (this.state.spacedRepetitionCycles[13] && this.state.spacedRepetitionCycles[13].learnt) ? 13 :
                                (this.state.spacedRepetitionCycles[14] && this.state.spacedRepetitionCycles[14].learnt) ? 14 :
                                (this.state.spacedRepetitionCycles[15] && this.state.spacedRepetitionCycles[15].learnt) ? 15 :
                                (this.state.spacedRepetitionCycles[16] && this.state.spacedRepetitionCycles[16].learnt) ? 16 :
                                (this.state.spacedRepetitionCycles[17] && this.state.spacedRepetitionCycles[17].learnt) ? 17 :
                                (this.state.spacedRepetitionCycles[18] && this.state.spacedRepetitionCycles[18].learnt) ? 18 :
                                (this.state.spacedRepetitionCycles[19] && this.state.spacedRepetitionCycles[19].learnt) ? 19 :
                                (this.state.spacedRepetitionCycles[19] && this.state.spacedRepetitionCycles[19].learnt) ? 20 : 21
                            }
                        >
                            <IonSelectOption value={21}>{window.ln.off}</IonSelectOption>
                            { this.state.spacedRepetitionCycles.map((item, i) => {
                                return (<IonSelectOption key={item.hours} value={i}>{Utilities.getGetOrdinal(i+1)}</IonSelectOption>)
                            }) }
                        </IonSelect>
                    </IonItem>

                    <IonItem lines="none">
                        <IonLabel>{window.ln.autoMarkMastered}</IonLabel>
                        <IonSelect
                            onIonChange={ async (i) => { 
                                let spacedRepetitionCycles = this.state.spacedRepetitionCycles;
                                for (let j = 0; j < spacedRepetitionCycles.length; j++) {
                                    if (i.detail.value === 21) {
                                        spacedRepetitionCycles[j].mastered = false;
                                    } else {
                                        spacedRepetitionCycles[j].mastered = (i.detail.value === j)
                                    }
                                }
                                Utilities.trackEvent("Spaced Repetition", "Spaced Repetition Update Mastered", null, i.detail.value);
                                this.setState({ spacedRepetitionCycles: spacedRepetitionCycles });
                                await SQLStorage.saveSetting("spacedRepetitionCycles", JSON.stringify(spacedRepetitionCycles))
                                await window.dropbox.queueForUpload("setting", "spacedRepetitionCycles");
                                store.dispatch(updatedSetsSet(['null']))
                                window.dropbox.debounce(true);
                            }} 
                            value={
                                (this.state.spacedRepetitionCycles[0] && this.state.spacedRepetitionCycles[0].mastered) ? 0 :
                                (this.state.spacedRepetitionCycles[1] && this.state.spacedRepetitionCycles[1].mastered) ? 1 :
                                (this.state.spacedRepetitionCycles[2] && this.state.spacedRepetitionCycles[2].mastered) ? 2 :
                                (this.state.spacedRepetitionCycles[3] && this.state.spacedRepetitionCycles[3].mastered) ? 3 :
                                (this.state.spacedRepetitionCycles[4] && this.state.spacedRepetitionCycles[4].mastered) ? 4 :
                                (this.state.spacedRepetitionCycles[5] && this.state.spacedRepetitionCycles[5].mastered) ? 5 :
                                (this.state.spacedRepetitionCycles[6] && this.state.spacedRepetitionCycles[6].mastered) ? 6 :
                                (this.state.spacedRepetitionCycles[7] && this.state.spacedRepetitionCycles[7].mastered) ? 7 :
                                (this.state.spacedRepetitionCycles[8] && this.state.spacedRepetitionCycles[8].mastered) ? 8 :
                                (this.state.spacedRepetitionCycles[9] && this.state.spacedRepetitionCycles[9].mastered) ? 9 :
                                (this.state.spacedRepetitionCycles[10] && this.state.spacedRepetitionCycles[10].mastered) ? 10 :
                                (this.state.spacedRepetitionCycles[11] && this.state.spacedRepetitionCycles[11].mastered) ? 11 :
                                (this.state.spacedRepetitionCycles[12] && this.state.spacedRepetitionCycles[12].mastered) ? 12 :
                                (this.state.spacedRepetitionCycles[13] && this.state.spacedRepetitionCycles[13].mastered) ? 13 :
                                (this.state.spacedRepetitionCycles[14] && this.state.spacedRepetitionCycles[14].mastered) ? 14 :
                                (this.state.spacedRepetitionCycles[15] && this.state.spacedRepetitionCycles[15].mastered) ? 15 :
                                (this.state.spacedRepetitionCycles[16] && this.state.spacedRepetitionCycles[16].mastered) ? 16 :
                                (this.state.spacedRepetitionCycles[17] && this.state.spacedRepetitionCycles[17].mastered) ? 17 :
                                (this.state.spacedRepetitionCycles[18] && this.state.spacedRepetitionCycles[18].mastered) ? 18 :
                                (this.state.spacedRepetitionCycles[19] && this.state.spacedRepetitionCycles[19].mastered) ? 19 :
                                (this.state.spacedRepetitionCycles[19] && this.state.spacedRepetitionCycles[19].mastered) ? 20 : 21
                            }
                        >
                            <IonSelectOption value={21}>{window.ln.off}</IonSelectOption>
                            { this.state.spacedRepetitionCycles.map((item, i) => {
                                return (<IonSelectOption key={item.hours} value={i}>{Utilities.getGetOrdinal(i+1)}</IonSelectOption>)
                            }) }
                        </IonSelect>
                    </IonItem>

                    <IonListHeader>
                        <IonLabel>{window.ln.tagManager}</IonLabel>
                    </IonListHeader>
                    
                    { (this.state.tags.length !== 0) && this.state.tags.map(tag => {
                        if ( (!tag) || (tag.id === "star") || (tag.id === "learnt") || (tag.id === "mastered") || (tag.id === "studying") || (tag.id === "new") || (tag.id === "image") || (tag.id === "recording") ) return null;
                        return (
                            <IonItemSliding key={tag.id}>
                                <IonItem>
                                    <IonLabel>{tag.name}</IonLabel>
                                </IonItem>
                                <IonItemOptions side="end">
                                    <IonItemOption color="primary" onClick={() => { this.editTag(tag.id) }}>{window.ln.edit}</IonItemOption>
                                    <IonItemOption color="danger" onClick={() => { this.setState({ toBeDeletedTagId: tag.id, deleteTagConfirmationAlert: true, }) }} >{window.ln.delete}</IonItemOption>
                                </IonItemOptions>
                            </IonItemSliding>
                        )
                    }) }

                    <IonItem onClick={() => {
                        if (this.state.tags.length > 9 && !window.activated) {
                            window.showSubscriptionModal("tags");
                        } else {
                            this.editTag("new")
                        }
                    }}>
                        <IonIcon icon={add} slot="end" />
                        <IonLabel>{window.ln.addTag}</IonLabel>
                    </IonItem>

                </IonList>
                </div>
            </IonContent>
            <TagEditorModal
                presentingElement={this.pageRef}
                currentlyEditedTag={this.state.currentlyEditedTag}
                onSave={(tag) => { this.saveTag(tag) }}
                onClose={() => { this.setState({ currentlyEditedTag: null }) }}
            />
            <IonAlert
                isOpen={this.state.deleteTagConfirmationAlert}
                onDidDismiss={() => { this.setState({ toBeDeletedTagId: null, deleteTagConfirmationAlert: false }) }}
                header={window.ln.tagDeletionH}
                message={window.ln.tagDeletionP}
                buttons={[
                    {
                        text: window.ln.cancel,
                        role: 'cancel',
                    },
                    {
                        text: window.ln.delete,
                        roel: 'delete',
                        handler: () => { this.deleteTag(this.state.toBeDeletedTagId) }
                    }
                ]}
            />

            <IonActionSheet
                isOpen={this.state.adminOpts}
                onDidDismiss={() => { this.setState({ adminOpts: null }) }}
                header={"D"}
                buttons={[
                    {
                        text: "Subscriptions",
                        handler: () => { 
                        localStorage.setItem("preventAppOpenTrack", "true")
                           window.location.href = "/subscriptions"
                        }
                    },
                    {
                        text: "Current Storage Type: " + ((window.useIndexedDb ? "IndexedDB" : "WebSQL")),
                        handler: () => { 
             
                        }
                    },
                    {
                        text: "Switch to IndexedDb",
                        handler: () => {
                            localStorage.setItem("indexedDbFallback5", "true");
                            localStorage.setItem("preventAppOpenTrack", "true")
                            window.location.reload();
                        }
                    },
                    {
                        text: "Attempt switch to WebSQL",
                        handler: () => {
                            localStorage.removeItem("indexedDbFallback5");
                            localStorage.setItem("preventAppOpenTrack", "true")
                            window.location.reload();
                        }
                    },
                    {
                        text: "Debug",
                        handler: () => {
                            if (localStorage.getItem("debug")) {
                                localStorage.removeItem("debug")
                            } else {
                                localStorage.setItem("debug", "true")
                            }
                            window.location.reload();
                        }
                    },
                    {
                        text: "CNC Branding " + (localStorage.getItem("cncBranding") ? "true" : "false"),
                        handler: () => {
                            if (localStorage.getItem("cncBranding")) {
                                localStorage.removeItem("cncBranding")
                            } else {
                                localStorage.setItem("cncBranding", "true")
                            }
                            window.location.reload();
                        }
                    },
                ]}
            />

            <IonAlert
                isOpen={this.state.spacedRepetitionEdited !== null}
                onDidDismiss={() => { this.setState({ spacedRepetitionEdited: null }) }}
                cssClass='my-custom-class'
                header={window.ln.daysAfterLastReview}
                inputs={[
                    {
                        name: 'hours',
                        placeholder: window.ln.daysAfterLastReview,
                        type: 'number',
                        min: 1,
                        max: 365,
                        value: this.state.spacedRepetitionEdited ? (this.state.spacedRepetitionEdited.value || null) : null
                    },
                ]}
                buttons={[
                    {
                        text: window.ln.cancel,
                        role: 'cancel',
                        cssClass: 'secondary',
                        handler: () => { }
                    },
                    {
                        text: window.ln.save,
                        handler: async (e) => {
                            let hours = e.hours * 24;
                            let spacedRepetitionCycles = this.state.spacedRepetitionCycles;
                            if (this.state.spacedRepetitionEdited.i === "new") {
                                spacedRepetitionCycles.push({ hours: hours });
                            } else {
                                spacedRepetitionCycles[this.state.spacedRepetitionEdited.i].hours = hours
                            }
                            Utilities.trackEvent("Spaced Repetition", "Spaced Repetition Update");
                            this.setState({ spacedRepetitionCycles: spacedRepetitionCycles });
                            await SQLStorage.saveSetting("spacedRepetitionCycles", JSON.stringify(spacedRepetitionCycles))
                            await window.dropbox.queueForUpload("setting", "spacedRepetitionCycles");
                            store.dispatch(updatedSetsSet(['null']))
                            window.dropbox.debounce(true);
                        }
                    }
                ]}
            />
            <LanguagePickerModal
                isOpen={this.state.languagePickerModal !== null}
                selected={this.state.languagePickerModal}
                onSelect={async (lang) => {
                    Utilities.trackEvent("Setting", "Setting Language Update", lang);
                    setTimeout( async () => {
                        let settings = this.state.settings;
                        settings.lang = lang
                        this.setState({ settings: settings, languagePickerModal: null });
                        await SQLStorage.saveSetting("lang", settings.lang);
                        await window.dropbox.queueForUpload("setting", "lang");
                        store.dispatch(updatedSetsSet(['null']))
                        window.dropbox.debounce(true);
                        localStorage.setItem("preventAppOpenTrack", "true")
                        window.location.href = "/"
                    }, 1000)
                }}
                presentingElement={this.state.pageRef ? this.state.pageRef : null}
                onDidDismiss={() => { this.setState({ languagePickerModal: null }) }}
            />
           <IonModal
                isOpen={this.state.accountAction !== false}
                swipeToClose={true}
                ref={this.entryModalRef}
                presentingElement={this.pageRef ? this.pageRef.current : null}
                onDidDismiss={() => {
                    this.setState({
                        accountAction: false
                    })
                }}
                mode={"ios"}
                className="dropbox-auth-modal account-modal"
            >
               { (this.state.accountAction) &&
                   <div className="swipeable-drawer-body" data-drawer="sync" style={{ overflow: 'auto' }}>
                       <IonHeader>
                            <IonToolbar style={{ paddingTop: 0 }}>
                                <IonTitle>{this.state.accountAction === "signup" ? window.ln.signUp : window.ln.logIn}</IonTitle>
                                <IonButtons slot="end">
                                    <IonIcon style={{ width: 24, height: 24, marginRight: 8, marginTop: -3, color: "#333" }} icon={close} onClick={() => { this.setState({ accountAction: false }) }} />
                                </IonButtons>
                            </IonToolbar>
                        </IonHeader>
                        <div>
                            { (this.state.dropboxToggled !== true) &&
                                <div 
                                    className="info-banner warning"
                                    style={{
                                        margin: 15
                                    }}
                                    onClick={() => {
                                        this.setState({
                                            accountAction: false,
                                            dropboxToggled: null
                                        }, () => {
                                            this.dropboxSyncToggle(true);
                                        })
                                    }}
                                >
                                    <IonIcon icon={alertCircleSharp} />
                                    <label>
                                        {window.ln.accountBackupDisclaimer}
                                        {/* <button>
                                            {window.ln.dropboxStep1Btn}
                                        </button> */}
                                    </label>
                                </div>
                            }
                            <div className='or' style={{ marginBottom: 10, marginTop: 35, textAlign: 'center' }}>
                                {this.state.accountAction !== "signup" ? window.ln.alreadyHaveAccount : window.ln.notAlreadyHaveAccount}
                            </div>
                            { (this.state.accountAction === "signup") ?
                                <IonList>
                                    <IonItem>
                                        <IonInput
                                            value={this.state.username}
                                            onIonChange={(e) => { this.setState({ username: e.target.value }) }}
                                            placeholder={window.ln.username}
                                            type="text"
                                        />
                                    </IonItem>
                                    <IonItem>
                                        <IonInput
                                            value={this.state.email}
                                            onIonChange={(e) => { this.setState({ email: e.target.value }) }}
                                            placeholder={window.ln.email}
                                            type="text"
                                        />
                                    </IonItem>
                                    <IonItem>
                                        <IonInput
                                            value={this.state.password}
                                            onIonChange={(e) => { this.setState({ password: e.target.value }) }}
                                            placeholder={window.ln.password}
                                            type="password"
                                            disabled={false}
                                        />     
                                    </IonItem>
                                </IonList>
                                :
                                <IonList>
                                    <IonItem>
                                        <IonInput
                                            value={this.state.usernameOrEmail}
                                            onIonChange={(e) => { this.setState({ usernameOrEmail: e.target.value }) }}
                                            placeholder={window.ln.username + " / " + window.ln.email}
                                            type="text"
                                        />
                                    </IonItem>
                                    <IonItem>
                                        <IonInput
                                            value={this.state.password}
                                            onIonChange={(e) => { this.setState({ password: e.target.value }) }}
                                            placeholder={window.ln.password}
                                            type="password"
                                        />       
                                    </IonItem>
                                </IonList>
                            }
                            { (this.state.accountStatus) &&
                                <div className="status error" style={{ margin: '0 15px' }}>
                                    {this.state.accountStatus}
                                </div>
                            }
                            <button disabled={false} className="default" onClick={ async () => {
                                let res = null;
                                this.setState({ fullscreenLoading: true })

                                if (this.state.accountAction === "signup") {
                                    res = await Server.signUp(this.state.email, this.state.username, this.state.password).catch(e => {
                                        this.setState({
                                            accountStatus: !e || !e.response ? window.ln.networkError : e.response.status === 400 ? window.ln.fillAllDetails : e.response.status === 409 ? window.ln.userAlreadyExists : window.ln.networkError
                                        })
                                    })
                                } else {
                                    res = await Server.logIn(this.state.usernameOrEmail, this.state.password).catch(e => {
                                        this.setState({
                                            accountStatus: !e || !e.response ? window.ln.networkError : e.response.status === 400 ? window.ln.fillAllDetails : e.response.status === 404 ? window.ln.noUserWithDetails : window.ln.networkError
                                        })
                                    })
                                }

                                this.setState({ fullscreenLoading: false })

                                if (res) {
                                    if (this.state.accountAction === "signup") {
                                        // TO DO LAng
                                        Utilities.trackEvent("Account", "Account Signup");
                                        window.toast("Successfully Signed Up", "success");
                                    } else {
                                        Utilities.trackEvent("Account", "Account Login");
                                        window.toast("Successfully Logged In", "success");
                                    }

                                    await SQLStorage.saveSetting("account", {
                                        ...res,
                                        id: res._id,
                                    });
                                    await window.dropbox.queueForUpload("setting", "account");
                                    store.dispatch(updatedSetsSet(['null']))
                                    window.dropbox.debounce(true);

                                    setTimeout(() => {
                                        localStorage.setItem("preventAppOpenTrack", "true")
                                        window.location.reload();
                                    }, 1000)
                                }
                            }}>
                               {this.state.accountAction === "signup" ? window.ln.signUp : window.ln.logIn}
                           </button>
                           <div className='or' style={{ marginTop: 35, textAlign: 'center' }}>
                               {this.state.accountAction === "signup" ? window.ln.alreadyHaveAccount : window.ln.notAlreadyHaveAccount}
                           </div>
                           <button className="default" onClick={() => {
                               this.setState({
                                    accountAction: this.state.accountAction === "signup" ? "login" : "signup"
                               })
                           }}>
                                {this.state.accountAction === "signup" ? window.ln.logIn : window.ln.signUp}
                           </button>
                        </div>
                   </div>
               }
           </IonModal>
           <IonActionSheet
                isOpen={this.state.contactUsSheet}
                onDidDismiss={() => { this.setState({ contactUsSheet: false }) }}
                buttons={[
                    { text: "WhatsApp", handler: () => {
                        Utilities.trackEvent("Contact", "Contact by WhatsApp", "Settings")
                        window.open("https://wa.me/36705359591?text=[App:FMS]")
                    } },
                    { text: "Email", handler: () => {
                        Utilities.trackEvent("Contact", "Contact by Email", "Settings")
                        window.open("mailto:hello@chillnstudy.com?subject=[App:FMS]")}
                    },
                ]}
            />
            <IonLoading
                isOpen={this.state.fullscreenLoading}
                message={window.ln.loading}
                duration={10000}
            />
          </IonPage>
        );
    }

};


export default withIonLifeCycle(Settings);
